import React from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import createAnimationHasSeenThirdTabSelector from "selectors/createAnimationHasSeenThirdTab";
import createAnimationSelectedAnimationTypeSelector from "selectors/createAnimationSelectedAnimationType";
import createAnimationSelectedTabSelector from "selectors/createAnimationSelectedTab";
import createAnimationUploadVideoStatusSelector from "selectors/createAnimationUploadVideoStatus";
import createAnimationHasDownloadedSelector from "selectors/createAnimationHasDownloaded";

const AnimationRightBar: React.FC = () => {
    const dispatch = useDispatch();

    const onTabSelected = React.useCallback(
        (tab: number) => () => {
            dispatch({
                type: "com.sage.actions.createAnimation.ISetTab",
                tab,
            } as sage.actions.createAnimation.ISetTab);
        },
        [dispatch]
    );
    const selectedTab = useSelector(createAnimationSelectedTabSelector);
    const animationType = useSelector(
        createAnimationSelectedAnimationTypeSelector
    );
    const uploadStatus = useSelector(createAnimationUploadVideoStatusSelector);
    const hasSeenThirdTab = useSelector(createAnimationHasSeenThirdTabSelector);
    const hasDownloaded: boolean = useSelector(
        createAnimationHasDownloadedSelector
    );

    const item2Enabled = !!animationType;
    const item3Enabled = item2Enabled && uploadStatus === "finished";
    const item4Enabled = item3Enabled && hasSeenThirdTab;
    const item5Enabled = item4Enabled && hasDownloaded;

    return (
        <Container>
            <Row>
                <Col>
                    <ListGroup>
                        <ListGroup.Item
                            action
                            onClick={onTabSelected(0)}
                            active={selectedTab === 0}
                            variant={animationType ? "success" : undefined}
                        >
                            1. Select Animation Type
                        </ListGroup.Item>
                        <ListGroup.Item
                            action
                            onClick={onTabSelected(1)}
                            active={selectedTab === 1}
                            variant={
                                uploadStatus === "finished"
                                    ? "success"
                                    : undefined
                            }
                            disabled={!item2Enabled}
                        >
                            2. Upload Video
                        </ListGroup.Item>
                        <ListGroup.Item
                            action
                            onClick={onTabSelected(2)}
                            active={selectedTab === 2}
                            variant={hasSeenThirdTab ? "success" : undefined}
                            disabled={!item3Enabled}
                        >
                            3. Review Animation
                        </ListGroup.Item>
                        <ListGroup.Item
                            action
                            onClick={onTabSelected(3)}
                            active={selectedTab === 3}
                            variant={hasDownloaded ? "success" : undefined}
                            disabled={!item4Enabled}
                        >
                            4. Download Result
                        </ListGroup.Item>
                        <ListGroup.Item
                            action
                            onClick={onTabSelected(4)}
                            active={selectedTab === 4}
                            disabled={!item5Enabled}
                        >
                            5. Use Animation
                        </ListGroup.Item>
                    </ListGroup>
                </Col>
            </Row>
        </Container>
    );
};

export default AnimationRightBar;
